export default ($axios) => ({
    $axios,

    async fetch() {
        return await $axios.get('/notifications?count=100')
    },

    async read(form) {
        return await $axios.post('/notifications/multiple-read', form)
    },
})
